import { createTelemetry, createTelemetryObject } from '@shared/core/analytics';

const category = 'workspace';
const pagePrefix = 'admin';

const telemetryObject = createTelemetryObject({
  pages: {
    workspace: () => ({
      category,
      pagePrefix,
      page: 'workspace',
    }),
  },
  actions: {
    workspaceMenuItemClicked: (label: string, location: 'workspace' | 'hamburger_menu') => ({
      action: 'WorkspaceMenuItemClicked',
      category,
      label,
      extraInfo: { location },
    }),
    shareWithCollaboratorsClicked: () => ({
      action: 'ShareWithCollaboratorsClicked',
      category,
    }),
    workspaceGridItemClicked: (instanceId: string) => ({
      action: 'WorkspaceGridItemClicked',
      category,
      label: instanceId,
    }),
  },
});

export const { useTelemetry: useWorkspaceTelemetry } = createTelemetry(telemetryObject);
